import * as React from "react";
import { useEffect } from "react";
import { Card, CardContent } from "../../../../shadcn/components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../../../../shadcn/components/ui/carousel";
import LeftArrowAccordian from "../../../../icons/LeftArrowAccordian";
import RightArrowAccordian from "../../../../icons/RightArrowAccordian";
import { getWatermarkedImgixUrl } from "services";

export function LocationsCarousel(props: any) {
  const [newSlides, setNewSlides] = React.useState(6);
  interface LocationsImages {
    imageLink: string;
    alt: string;
    name: string;
  }

  const locationsImages: LocationsImages[] = [
    {
      imageLink: getWatermarkedImgixUrl(
        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/50ec3781-c5e2-4832-b350-f72ec2a2d662`,
      ),
      alt: "Ahmedabad",
      name: "Ahmedabad",
    },
    {
      imageLink: getWatermarkedImgixUrl(
        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/ea013a26-0dc0-42be-94ea-1a225b2a5f6d`,
      ),
      alt: "Chennai",
      name: "Chennai",
    },
    {
      imageLink: getWatermarkedImgixUrl(
        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/8124cd68-5c39-4c06-abd6-81377471fe90`,
      ),
      alt: "Coimbatore",
      name: "Coimbatore",
    },
    {
      imageLink: getWatermarkedImgixUrl(
        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/f0f4d942-ca63-49c0-a2ed-6a44ddc984b4`,
      ),
      alt: "Hyderabad",
      name: "Hyderabad",
    },
    {
      imageLink: getWatermarkedImgixUrl(
        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/959b41c7-630a-42a7-b66e-f61a6e946a00`,
      ),
      alt: "Indore",
      name: "Indore",
    },
    {
      imageLink: getWatermarkedImgixUrl(
        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/5627980a-e9fa-4249-9a86-c650b858e0f5`,
      ),
      alt: "Kolkata",
      name: "Kolkata",
    },
    {
      imageLink: getWatermarkedImgixUrl(
        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/da6d08bb-7e8f-42d2-966c-d817d976dc30`,
      ),
      alt: "Mumbai",
      name: "Mumbai",
    },
    {
      imageLink: getWatermarkedImgixUrl(
        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/0b3d1dc2-7221-48f9-ac18-abee739ba75e`,
      ),
      alt: "NCR",
      name: "NCR",
    },
    {
      imageLink: getWatermarkedImgixUrl(
        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/0e45dc97-f932-43e5-a160-b041cb8de127`,
      ),
      alt: "Pune",
      name: "Pune",
    },
    {
      imageLink: getWatermarkedImgixUrl(
        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/91273a6c-c9cc-4a9e-ac2e-228ff8e714ef`,
      ),
      alt: "Surat",
      name: "Surat",
    },
    {
      imageLink: getWatermarkedImgixUrl(
        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/f5dcf0f3-f0cb-4d78-8cd4-25d64f790857`,
      ),
      alt: "Vijayawada",
      name: "Vijayawada",
    },
    {
      imageLink: getWatermarkedImgixUrl(
        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/8f270689-b425-4649-816a-176a7dac287a`,
      ),
      alt: "Vizag",
      name: "Vizag",
    },
  ];

  // Handling wdith change
  useEffect(() => {
    const mediaQueryMd = window.matchMedia("(min-width: 1240px)");
    const handleMediaChange = () => {
      if (mediaQueryMd.matches) {
        setNewSlides(6);
      } else {
        setNewSlides(3);
      }

      // Add event listener for media query changes
      mediaQueryMd.addListener(handleMediaChange);
      // Cleanup event listener on component unmount
      return () => mediaQueryMd.removeListener(handleMediaChange);
    };

    handleMediaChange();
  }, []);

  return (
    <Carousel
      className="w-full px-10  "
      opts={{ align: "start", loop: true, slidesToScroll: 3 }}
    >
      <CarouselContent className="ml-0 mid:mx-5">
        {locationsImages.map((item, index) => (
          <CarouselItem
            key={index}
            className="pl-0  basis-1/3 md:basis-1/4 mid:basis-1/6"
          >
            <div className="w-full flex justify-center items-center">
              <Card className="w-[70px] h-[58px] lg:w-[114px] lg:h-[94px] rounded-none relative clip-path-topLeftPolygon lg:clip-path-topLeftPolygon">
                <CardContent className="flex w-full h-full items-center justify-center p-0">
                  <img
                    src={item.imageLink}
                    alt={item.alt}
                    className="w-full h-full"
                  />
                  <div className="absolute w-full h-full flex items-center justify-center bg-black/40">
                    <div className="bg-transparent absolute bottom-2 lg:bottom-4 font-openSans font-normal text-mobile-body-sm lg:text-[18px] leading-4 lg:leading-7 text-white ">
                      {" "}
                      {item.name}
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious
        className="w-9 h-8 left-0 lg:-left-6 lg:h-[52px] lg:w-[68px] rounded-lg border-brand-textLightGrey bg-transparent"
        icon={
          <LeftArrowAccordian className="w-3 h-[14px] lg:w-[21px] lg:h-[26px]" />
        }
      />
      <CarouselNext
        className="w-9 h-8 right-0 lg:-right-6 lg:h-[52px] lg:w-[68px] rounded-lg border-brand-textLightGrey bg-transparent"
        icon={
          <RightArrowAccordian className="w-3 h-[14px] lg:w-[21px] lg:h-[26px]" />
        }
      />
    </Carousel>
  );
}
